<template>
<div :class="$style.scrollbar" :gkscrollbar-color="color" gk-scrollbar>
  <div :class="$style['scrollbar-outer']">
    <!-- <gkDrag
      v-if="drag"
      :touch="touch"
      :range="scrollbarRange"
      inertia
      scroll
      auto
      @start="handleScrollbarStart"
      @move="handleScrollbarMove"
      @end="handleScrollbarEnd"
    >
      <div ref="scrollbar" :class="$style['scrollbar-wrapper']" gkscrollbar-ctrl :style="wrapperStyle" @wheel="handleScroll">
        <div ref="inner" :class="$style['scrollbar-inner']" gk-scrollbar-inner>
          <slot />
        </div>
      </div>
    </gkDrag> -->

    <!-- <div ref="scrollbar" :class="$style['scrollbar-wrapper']" :style="wrapperStyle" @wheel="handleScroll" v-else> -->
    <div ref="scrollbar" :class="$style['scrollbar-wrapper']" :style="wrapperStyle" @scroll="handleScroll">
      <div ref="inner" gk-scrollbar-inner>
        <slot />
      </div>
    </div>
  </div>

  <ScrollbarThumb
    v-if="useScrollbarX"
    type="x"
    :scrollWidth="width"
    :touch="touch"
    :scale="scaleX"
    v-model="thumbLeft"
    @left="handlePullThumbLeft"
  />

  <ScrollbarThumb
    v-if="useScrollbarY"
    type="y"
    :scrollHeight="height"
    :touch="touch"
    :scale="scaleY"
    v-model="thumbTop"
    @top="handlePullThumbTop"
  />
</div>
</template>

<script>
import VueTypes from 'vue-types'
import scrollbarWidth from '../../utils/scrollbar.width'
import {addResizeListener, removeResizeListener} from '../../utils/resize-event'

import gkDrag from '../drag/drag'
import ScrollbarThumb from './ScrollbarThumb'

export default {
  name: 'gkui-scrollbar',
  components: {
    gkDrag,
    ScrollbarThumb
  },
  props: {
    color: VueTypes.string.def('base'),
    noresize: VueTypes.bool.def(false),
    drag: VueTypes.bool.def(false),
    touch: VueTypes.bool.def(false),
    maxHeight: VueTypes.number
  },
  data () {
    return {
      useScrollbarX: false,
      useScrollbarY: false,
      scrollbarRange: {},
      scaleY: 1,
      scaleX: 1,
      width: 0,
      height: 0,
      scrollWidth: 0,
      scrollHeight: 0,
      scrollLeftMax: 0,
      scrollTopMax: 0,
      thumbLeft: 0,
      thumbTop: 0
    }
  },
  computed: {
    /**
     * toDo，有个奇怪的 bug 在不使用滚动功能的时候如果附加 margin 负值时会导致丢失一部分高度或者宽度
     * 获取浏览器的滚动条宽度，附加在 wrapper 上
     */
    wrapperStyle () {
      const space = scrollbarWidth()
      const spaceWidth = `-${space}px`
      const style = {}

      if (space) {
        if (this.useScrollbarX) {
          style.marginRight = spaceWidth
        }

        if (this.useScrollbarY) {
          style.marginBottom = spaceWidth
        }
      }

      return style
    }
  },
  watch: {
    scrollTop (value) {
      this.$inner.scrollTop = value
    }
  },
  created () {
  },
  mounted () {
    this.initRange()

    !this.noresize && addResizeListener(this.$refs.scrollbar, this.initRange)
    !this.noresize && addResizeListener(this.$refs.inner, this.initRange)
  },
  beforeDestroy () {
    !this.noresize && removeResizeListener(this.$refs.scrollbar, this.initRange)
    !this.noresize && removeResizeListener(this.$refs.inner, this.initRange)
  },
  methods: {
    /**
     * 初始化滚动条的各种参数
     */
    initRange () {
      const $scrollbar = this.$refs.scrollbar
      const scrollbarWidth = $scrollbar.clientWidth
      const scrollbarHeight = $scrollbar.clientHeight

      // 获取内容的 scroll 尺寸，用于模拟 scroll
      const innerWidth = $scrollbar.scrollWidth
      const innerHeight = $scrollbar.scrollHeight

      // 获取真实的内容尺寸，只用于计算是否使用 scroll
      let innerClientWidth = this.$refs.inner.clientWidth
      let innerClientHeight = this.$refs.inner.clientHeight

      // 根据内容计算真正的宽度
      this.$refs.inner.children && Array.prototype.slice.call(this.$refs.inner.children).forEach(el => {
        innerClientWidth = Math.max(innerClientWidth, el.clientWidth)
      })

      // 比例为内容区域的比例
      const scaleX = scrollbarWidth / innerWidth
      const scaleY = scrollbarHeight / innerHeight

      this.width = innerWidth
      this.height = innerHeight
      this.scrollWidth = scrollbarWidth
      this.scrollHeight = scrollbarHeight
      this.scrollLeftMax = innerWidth - scrollbarWidth
      this.scrollTopMax = innerHeight - scrollbarHeight

      this.scaleX = scaleX
      this.scaleY = scaleY

      if (scrollbarWidth >= innerClientWidth && scrollbarHeight >= innerClientHeight) {
        this.useScrollbarX = false
        this.useScrollbarY = false

        return
      }

      this.useScrollbarX = scrollbarWidth < innerClientWidth
      this.useScrollbarY = scrollbarHeight < innerClientHeight

      this.$emit('inited', {
        x: this.useScrollbarX,
        y: this.useScrollbarY
      })

      this.emitLeft()
      this.emitTop()

      this.$nextTick(() => {
        this.scrollbarRange = {
          xmin: -innerWidth + scrollbarWidth,
          xmax: 0,
          ymin: -innerHeight + scrollbarHeight,
          ymax: 0
        }
      })
    },
    handleScrollbarStart (x, y, ev) {},
    handleScrollbarMove (x, y, left, top, ev) {
      this.scrollTop(-top)

      this.thumbTop = -top
    },
    handleScrollbarEnd () {},
    /**
     * scroll 事件，包含 x 和 y 轴
     */
    handleScroll () {
      this.scrollLeft()
      this.scrollTop()
      this.emitLeft()
      this.emitTop()
    },
    /**
     * thumb 滚动后同步 scrollbar 的 scrollLeft 值
     */
    handlePullThumbLeft (left) {
      this.$refs.scrollbar.scroll(left, this.$refs.scrollbar.scrollTop)

      this.emitLeft()
    },
    /**
     * thumb 滚动后同步 scrollbar 的 scrollTop 值
     */
    handlePullThumbTop (top) {
      this.$refs.scrollbar.scroll(this.$refs.scrollbar.scrollLeft, top)

      this.emitTop()
    },
    /**
     * 通知 thumb 同步 scrollLeft
     * @param {Number} [left] 设置 scrollLeft
     */
    scrollLeft (left) {
      left && this.handlePullThumbLeft(left)

      this.thumbLeft = left || this.$refs.scrollbar.scrollLeft
    },
    /**
     * 通知 thumb 同步 scrollTop
     * @param {Number} [top] 设置 scrollTop
     */
    scrollTop (top) {
      top && this.handlePullThumbTop(top)

      this.thumbTop = top || this.$refs.scrollbar.scrollTop
    },
    /**
     * 上报 scrollLeft 的值
     */
    emitLeft () {
      const left = this.$refs.scrollbar.scrollLeft

      this.$emit('scrollLeft', left, left >= this.scrollLeftMax)
    },
    /**
     * 上报 scrollTop 的值
     */
    emitTop () {
      const top = this.$refs.scrollbar.scrollTop

      this.$emit('scrollTop', top, top >= this.scrollTopMax)
    }
  }
}
</script>

<style lang="scss" module>

.scrollbar {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.scrollbar-outer {
  overflow: hidden;
  flex: 1;
}
.scrollbar-wrapper {
  overflow: scroll;
  width: 100%; height: 100%;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0; height: 0;
    opacity: 0;
  }
}
</style>

